import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=fa162e04&scoped=true"
import script from "./InformationModal.vue?vue&type=script&lang=ts"
export * from "./InformationModal.vue?vue&type=script&lang=ts"
import style0 from "./InformationModal.vue?vue&type=style&index=0&id=fa162e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa162e04",
  null
  
)

export default component.exports